import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

/**
 * Subscribes to real-time health_alerts inserts for the current member
 * and shows a toast notification when a new alert is created.
 */
export function useHealthAlertNotifications() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel("health-alerts-realtime")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "health_alerts",
        },
        (payload) => {
          if (payload.new.member_id === user.id) {
            const metric = payload.new.metric as string;
            const alertType = payload.new.alert_type as string;

            const label = alertType === "sdoh" ? "SDOH Alert" : "Health Alert";

            toast.warning(label, {
              description: `${metric}: ${payload.new.value}`,
              duration: 10000,
            });

            // Refresh alerts queries
            queryClient.invalidateQueries({ queryKey: ["member-health-alerts", user.id] });
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user, queryClient]);
}
